// Independent first-party transport. Only anonymous IDs and registry/DOM IDs enter it.
const EVENTS = [
	'page_view',
	'section_view',
	'cta_click',
	'form_start',
	'generate_lead'
];
const randomId = () => {
	const bytes = window.crypto.getRandomValues(new Uint8Array(16));
	bytes[6] = (bytes[6] & 15) | 64;
	bytes[8] = (bytes[8] & 63) | 128;
	const value = Array.from(bytes, (byte) =>
		byte.toString(16).padStart(2, '0')
	).join('');
	return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(
		12,
		16
	)}-${value.slice(16, 20)}-${value.slice(20)}`;
};
let visitor = '',
	session: { id: string; expires: number; source: string } | null = null;
let visit = '',
	page = '',
	count = 0;
function source() {
	try {
		const referrer = new URL(document.referrer);
		return ['mrdevello.com', 'www.mrdevello.com'].includes(
			referrer.hostname
		)
			? 'direct'
			: referrer.hostname.toLowerCase();
	} catch {
		return 'direct';
	}
}
function identity() {
	const timestamp = Date.now();
	if (!visitor) {
		try {
			const stored = JSON.parse(
				localStorage.getItem('mrd-visitor-v1') || 'null'
			);
			visitor = stored?.expires > timestamp ? stored.id : randomId();
			localStorage.setItem(
				'mrd-visitor-v1',
				JSON.stringify({
					id: visitor,
					expires: timestamp + 365 * 86400000
				})
			);
		} catch {
			visitor = visitor || randomId();
		}
	}
	if (!session) {
		try {
			session = JSON.parse(
				sessionStorage.getItem('mrd-visit-session-v1') || 'null'
			);
		} catch {
			/* optional storage */
		}
	}
	if (!session || session.expires <= timestamp) {
		session = {
			id: randomId(),
			expires: timestamp + 1800000,
			source: source()
		};
		visit = '';
		page = '';
	}
	session.expires = timestamp + 1800000;
	try {
		sessionStorage.setItem('mrd-visit-session-v1', JSON.stringify(session));
	} catch {
		/* optional storage */
	}
	return {
		visitorId: visitor,
		sessionId: session.id,
		source: session.source
	};
}
export function sendVisitorMetric(
	type: string,
	params: Record<string, string>
) {
	if (
		!EVENTS.includes(type) ||
		!params.page_id ||
		!window.fetch ||
		!window.crypto
	)
		return;
	try {
		const ids = identity();
		if (
			!visit ||
			page !== params.page_id ||
			type === 'page_view' ||
			count >= 500
		) {
			visit = randomId();
			page = params.page_id;
			count = 0;
		}
		count++;
		let device = 'desktop';
		if (window.innerWidth < 1100) device = 'tablet';
		if (window.innerWidth < 768) device = 'mobile';
		const body = JSON.stringify({
			eventId: randomId(),
			...ids,
			visitId: visit,
			type,
			pageId: params.page_id,
			device,
			...(params.section_id ? { sectionId: params.section_id } : {}),
			...(params.cta_id ? { ctaId: params.cta_id } : {})
		});
		const send = (retry: boolean) =>
			window
				.fetch('/api/admin/collect', {
					method: 'POST',
					credentials: 'same-origin',
					cache: 'no-store',
					keepalive: true,
					headers: { 'content-type': 'application/json' },
					body
				})
				.then((response) => {
					if (retry && response.status >= 500)
						setTimeout(() => {
							void send(false).catch(() => {});
						}, 1500);
				})
				.catch(() => {
					if (retry)
						setTimeout(() => {
							void send(false).catch(() => {});
						}, 1500);
				});
		void send(true);
	} catch {
		/* Analytics must never interrupt navigation or an inquiry. */
	}
}
